<template>
    <div class="main-page">
        <div class="main-page__inner">

            <!-- <div
                v-if="textOpened" 
                class="main-page__notification main-page-notification">
                <p class="main-page-notification__text">В связи с большим количеством заказов, оплата на сайте временно отключена.</p>
                <p class="main-page-notification__text">Вы можете оставить заявку по телефону +7 921 807 7750. И указать название интересующей вас позиции.</p>
                <p class="main-page-notification__text">Время ответа операторов увеличено. Приносим извинения за неудобства.</p>    

                <button 
                    @click="closeText"
                    type="button"
                    class="popup__close-text"></button>            
            </div> -->

            <Header class="main-page__header header-bg container"/>
            <Banner class="main-page__banner offset container container-ban"/>
            <PopularFlowers class="main-page__pop-flowers offset"/>
            <div class="container">
                <MainCategories class="main-page__main-categories offset"/>
                <MainHelp class="main-page__main-help offset"/>
                <ClientArticles 
                    v-if="articles.length"
                    class="main-page__main-articles offset"/>
                <About
                    id="about" 
                    class="main-page__main-about offset"/>
                <Footer class="main-page__main-footer offset"/>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Header from '@/components/Header'
import Banner from '@/components/Banner'
import PopularFlowers from '@/components/Popular-flowers'
import MainCategories from '@/components/Main-categories'
import MainHelp from '@/components/Main-help'
import About from '@/components/About'
import Footer from '@/components/Footer'
import ClientArticles from '@/components/Client-articles'


export default {
    data() {
        return {
            articles: [],
            textOpened: true
        }
    },
    components: {
        Header,
        Banner,
        PopularFlowers,
        MainCategories,
        MainHelp,
        About,
        Footer,
        ClientArticles
    },
    methods: {
        getArticles(){
            axios({
                method: 'GET',
                url: 'https://lenbuket.ru:8443/api/article/get'
            }).then((res)=>{
                this.articles = res.data
            })
        },
        closeText(){
            this.textOpened = false
        }
    },
    mounted() {
        this.getArticles()
        document.body.style.overflowY = 'scroll'
    },
}
</script>

<style scoped>
    .main-page__inner{
        position: relative;
    }
    .main-page__notification{
        position: fixed;
        bottom: 0;
        left: 50%;
        max-width: 500px;
        background-color: #fff;
        border-radius: 40px 40px 0 0;
        z-index: 999999;
        padding: 20px;
        padding-top: 45px;
        box-shadow: 0 3px 5px rgba(0, 0, 0, 0.25);
        text-align: center;
        margin-left: -250px;
    }
    .popup__close-text{
        position: absolute;
        top: 15px;
        right: 15px;
        height: 25px;
        width: 25px;
        transition: all linear .2s;
        border-radius: 6px;
    }
    .popup__close-text:hover{
        background-color: rgba(0, 0, 0, .5);
    }
    .popup__close-text::before{
        position: absolute;
        content: "";
        height: 4px;
        width: 25px;
        background-color: #BFBFBF;
        top: 10px;
        right: 0;
        border-radius: 20px;
        transform: rotate(45deg);
    }
    .popup__close-text::after{
        position: absolute;
        content: "";
        height: 4px;
        width: 25px;
        background-color: #BFBFBF;
        top: 10px;
        right: 0;
        border-radius: 20px;
        transform: rotate(-45deg);
    }
    .main-page-notification__text{
        margin-bottom: 5px;
    }
    @media (max-width: 600px) {
        .container-ban{
            padding-left: 0;
            padding-right: 0;
        }
        .main-page__notification{
            width: 100%;
            left: 0;
            margin-left: 0;
        }
    }
</style>